import DOMPurify from 'dompurify';

const ALLOWED_DOCUMENTATION_HTML_TAGS = [
  'p',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'ul',
  'ol',
  'li',
  'a',
  'img',
  'figure',
  'figcaption',
  'table',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
  'pre',
  'code',
  'blockquote',
  'em',
  'strong',
  'b',
  'i',
  'u',
  'br',
  'hr',
  'span',
  'div',
  'iframe',
  'section',
  'article',
];

const ALLOWED_DOCUMENTATION_HTML_ATTRS = [
  'href',
  'src',
  'alt',
  'title',
  'class',
  'id',
  'target',
  'rel',
  'width',
  'height',
  'colspan',
  'rowspan',
  'name',
  'allow',
  'allowfullscreen',
  'frameborder',
  'loading',
];

export function sanitizeDocumentationHtml(html: string): string {
  if (!html) {
    return '';
  }

  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ALLOWED_DOCUMENTATION_HTML_TAGS,
    ALLOWED_ATTR: ALLOWED_DOCUMENTATION_HTML_ATTRS,
    ALLOW_DATA_ATTR: false,
    ADD_ATTR: ['target', 'rel'],
  });
}
